import type { ParagraphMeta, ParagraphType, TimeControl } from './components';
import type { JsonApiParagraphMeta } from './jsonapi';
import type { DrupalPromotion, PromotionBannerType, PromotionUserStatusType } from './promotion';

export enum SnippetTypeList {
  promotionBanner = 'content_snippet_bundled--promotionbanner',
  serviceLayerDv = 'content_snippet_bundled--service_layer_dv',
  contentBannerMba = 'content_snippet_bundled--contentbanner_mba',
}

export type PromotionBannerItemType = Omit<ContentSnippetItemType, 'field_paragraph'> & {
  type: `${SnippetTypeList.promotionBanner}`;
  field_display_app: boolean;
  field_display_web: boolean;
  field_paragraph: PromotionBannerType;
  label: string;
  bundle: {
    type: 'content_snippet_bundled_type--content_snippet_bundled_type';
    id: string;
    meta: {
      drupal_internal__target_id: string;
    };
  };
  field_user_status: {
    data?: null;
    name?: string;
  };
};

export type ServiceLayerType = ContentSnippetItemType & {
  type: `${SnippetTypeList.serviceLayerDv}`;
};

export type MbaBannerType = ContentSnippetItemType & {
  type: `${SnippetTypeList.contentBannerMba}`;
};

type ContentSnippetItemType = JsonApiParagraphMeta &
  ParagraphMeta &
  TimeControl & {
    name?: string;
    field_assortment_text?: string;
    field_assortment:
      | string[]
      | [
          {
            type: 'taxonomy_term--assortment';
            id: string;
            meta?: {
              drupal_internal__target_id: number;
            };
          },
        ];
    field_paragraph: ParagraphType;
    field_user_status?:
      | PromotionUserStatusType
      | {
          data: null;
          links: {
            related?: {
              href: string;
            };
            self: {
              href: string;
            };
          };
        };
    bundle?: {
      type: 'content_snippet_bundled_type--content_snippet_bundled_type';
      id: string;
      meta: {
        drupal_internal__target_id: string;
      };
    };
  };

export type ContentSnippetType =
  | PromotionBannerItemType
  | ServiceLayerType
  | MbaBannerType
  | DrupalPromotion;
